import GraphicEqIcon from '@mui/icons-material/GraphicEq';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { Box, Button, Link, Typography } from '@mui/material';
import WorkFolderSection, { workFolderUrl } from '../work/WorkFolderSection';

/** The translator's room, the shared folder and the rest of what the work happens in. */
const TaskWork = ({
    task,
    detail,
    perms,
    showEditor,
    subtitleVideo,
    busy,
    onOpenEditor,
    onOpenSubtitleVideo,
    hint,
    conversion,
    converting,
    convertLine,
    onConvert,
    videoProblem,
    onFlagVideo,
    strip,
    boxes,
}) => {
    const folder = !task.redacted && (task.contentType === 'VIDEO' || task.contentType === 'AUDIO' || detail.post) && (
        <WorkFolderSection task={task} summary={detail.workFolder} />
    );
    const hasWork = strip || showEditor || subtitleVideo || boxes || conversion?.canConvert || detail.workFolder;
    if (!hasWork || task.redacted) return strip || null;
    return (
        <Box sx={{ mt: 2 }}>
            <Typography variant="overline" component="div" color="text.secondary">
                Your work
            </Typography>
            {strip}
            {showEditor && (
                <Button
                    size="small"
                    variant="outlined"
                    startIcon={<OpenInNewIcon />}
                    disabled={busy}
                    onClick={onOpenEditor}
                >
                    Open in editor
                </Button>
            )}
            {subtitleVideo &&
                (subtitleVideo.onVideo ? (
                    <Button size="small" variant="outlined" startIcon={<OpenInNewIcon />} onClick={onOpenSubtitleVideo}>
                        Open in editor
                    </Button>
                ) : (
                    <Typography variant="body2" color="text.secondary">
                        {videoProblem}{' '}
                        {perms.canFlag && (
                            <Link component="button" variant="body2" onClick={onFlagVideo}>
                                Flag for PM
                            </Link>
                        )}
                    </Typography>
                ))}
            {hint && (
                <Typography variant="caption" color="text.secondary" component="div" sx={{ mt: 0.5 }}>
                    {hint}
                </Typography>
            )}
            {conversion?.canConvert && (
                <Box sx={{ mt: 1.5 }}>
                    <Button
                        variant="outlined"
                        size="small"
                        startIcon={<GraphicEqIcon />}
                        disabled={converting}
                        onClick={onConvert}
                    >
                        New Dubbing Audio
                    </Button>
                    {convertLine && (
                        <Typography
                            variant="body2"
                            color={convertLine.error ? 'error' : 'text.secondary'}
                            sx={{ mt: 0.75 }}
                            role="status"
                        >
                            {convertLine.text}
                            {convertLine.done && (
                                <>
                                    {' '}
                                    <Link
                                        href={workFolderUrl(task.contentId, task.languageKey)}
                                        target="_blank"
                                        rel="noopener"
                                    >
                                        Open folder ↗
                                    </Link>
                                </>
                            )}
                        </Typography>
                    )}
                </Box>
            )}
            {folder}
            {boxes}
        </Box>
    );
};

export default TaskWork;
